import type { DiamRoleDetails, DiamRoleInclusionRequest } from '../../diamApi';
import {
  collectFunctionalRoleAttributeIds,
  unscopeCreateRoleContentIds,
} from './mapCreateRoleContentsTree';

export function mapCreateRoleInclusions(
  selectedContents: readonly string[],
  functionalRoles: readonly DiamRoleDetails[],
): DiamRoleInclusionRequest[] {
  const selected = new Set(selectedContents);
  const inclusions: DiamRoleInclusionRequest[] = [];

  for (const role of functionalRoles) {
    if (role.type !== 'FUNCTIONAL') {
      continue;
    }

    if (selected.has(`group:${role.roleId}`)) {
      inclusions.push({
        type: 'ROLE',
        roleId: role.roleId,
      });
      continue;
    }

    const scopedSelected = new Set(
      unscopeCreateRoleContentIds(role.roleId, selectedContents),
    );

    const roleSelectionId = `role:${role.roleId}`;
    const attributeIds = collectFunctionalRoleAttributeIds(role);

    if (selected.has(roleSelectionId) || scopedSelected.has(roleSelectionId)) {
      inclusions.push({
        type: 'ROLE',
        roleId: role.roleId,
      });
      continue;
    }

    const selectedAttributeIds = attributeIds.filter(attributeId =>
      scopedSelected.has(attributeId),
    );

    if (selectedAttributeIds.length === 0) {
      continue;
    }

    if (
      attributeIds.length > 0 &&
      selectedAttributeIds.length === attributeIds.length
    ) {
      inclusions.push({
        type: 'ROLE',
        roleId: role.roleId,
      });
      continue;
    }

    inclusions.push({
      type: 'ATTRIBUTES',
      roleId: role.roleId,
      attributeIds: selectedAttributeIds,
    });
  }

  return inclusions;
}
